import {booleanAttribute, Component, input} from '@angular/core';
import {Tone} from '../ui-colors';

/**
 * Status pill (dot + text in the tone colors). `variant="tag"` is the square work item label
 * without dot ("Active", "Resolved"); `variant="chip"` the grey rounded label for roles.
 */
@Component({
    selector: 'app-status-badge',
    templateUrl: './status-badge.component.html',
    styleUrl: './status-badge.component.scss',
    host: {
        '[class]': '"tone-" + tone() + " " + variant()',
        '[class.small]': 'size() === "sm"'
    }
})
export class StatusBadgeComponent {
    readonly tone = input<Tone>('neutral');
    readonly variant = input<'pill' | 'tag' | 'chip'>('pill');
    readonly size = input<'sm' | 'md'>('md');
    readonly dot = input(true, {transform: booleanAttribute});
}
